import React from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel"; // Added this
import FormControl from "@mui/material/FormControl"; // Added this
import clsx from "clsx";
import CONSTANTS from '../../utils/constants/UIConstants';

interface DropDownFieldsProps {
	value: string;
	onChange: (value: string) => void;
	options: string[];
	addStyle?: string;
	label: string;
	disabled?: boolean;
	addLabelStyle?: string;
	height?: number;
	selectRef?: React.RefObject<HTMLDivElement>;
}
const defaultHeight = 48;
const DropDownFields: React.FC<DropDownFieldsProps> = ({
	value,
	onChange,
	options,
	addStyle,
	addLabelStyle,
	label,
	disabled = false,
	height = defaultHeight,
	selectRef = undefined,
}) => {
	const handleDropdownChange = (event: SelectChangeEvent<string>) => {
		onChange(event.target.value as string);
	};

	return (
		<FormControl
			variant="outlined"
			sx={{
				borderRadius: 2,
				".MuiOutlinedInput-root": {
					borderRadius: 0.5,
					"&.Mui-disabled": {
						color: "#556670", // Change text color
						"& .MuiOutlinedInput-notchedOutline": {
							borderColor: "transparent", // Remove the border
						},
						"& .MuiSelect-icon": {
							display: "none", // Hide the arrow icon
						},
					},
				},
			}}
			>
			<InputLabel htmlFor="label" className={addLabelStyle}
			sx={{
				'& .MuiInputLabel-root.MuiInputLabel-shrink':  {
						maxWidth: label.length >= 10 ? '130%' : '100%',
						backgroundColor: CONSTANTS.TEXT_INPUT_LABEL_BACKGROUND,
						padding: '0.25rem 0.8rem 0 0.35rem',
						marginLeft: '-0.35rem',
						marginTop: '-0.10rem',
						borderRadius: '5px',
				},
				'&.MuiInputLabel-shrink': {
					maxWidth: label.length >= 10 ? '130%' : '100%',
					backgroundColor: CONSTANTS.TEXT_INPUT_LABEL_BACKGROUND,
					padding: '0 0.35rem 0 0.35rem',
					marginLeft: '-0.35rem',
					marginTop: '-0.10rem',
					borderRadius: '5px',
					overflow: 'visible',
					whiteSpace: 'nowrap',
					zIndex: 1,
				},
				
			}}>
				{label}
			</InputLabel>
			<div ref={selectRef} tabIndex={-1}>
				<Select
					label={label}
					id={label}
					value={value}
					onChange={handleDropdownChange}
					className={clsx(
						"!font-inter",
						`!h-[${height}px]`,
						"!font-normal",
						"!text-[14px]",
						"!leading-[18px]",
						addStyle
					)}
					MenuProps={{
						PaperProps: {
							sx: {
								".MuiMenuItem-root": {
									height: "36px",
									fontFamily: "inter, sans-serif",
									backgroundColor: "transparent",
									"&:hover": {
										backgroundColor: "#F4F8F9 !important",
									},
								},
								".MuiMenuItem-root.Mui-selected": {
									backgroundColor: "transparent !important",
									"&:hover": {
										backgroundColor: "#F4F8F9 !important",
									},
								},
							},
						},
					}}
					disabled={disabled} // Added disabled prop to Select
					
				>
			
				{options.map((option) => (
					<MenuItem key={option} value={option} className="!font-inter">
						{option}
					</MenuItem>
				))}
			</Select>
			</div>
		</FormControl>
	);
};

export default DropDownFields;
